export default "__VITE_ASSET__Go0BfkCu__"